<div class="reg-view-setting-column" [class.no-line]="logicRules.length">
  <div class="checkbox abc-checkbox abc-checkbox-primary form-check-inline form-check">
    <input
      [id]="fieldSetting.itemId"
      class="styled"
      type="checkbox"
      [name]="fieldSetting.itemId"
      [(ngModel)]="fieldSetting.visible"
      [disabled]="fieldSetting?.isDisabled"
      (change)="onFieldSelectionChange.emit()"
    />
    <label class="default-label checkbox-label checkbox-label-setting" [for]="fieldSetting.itemId">{{
      label
    }}</label>
  </div>
  <div class="checkbox-handle">
    <i class="cc-icon cc-icon-grip-bar-horizontal handle sm-cursor-grab"></i>
  </div>
</div>

<div *ngFor="let logicRule of logicRules" class="mb-2">
  <div class="text-muted d-flex align-items-center">
    <i class="cc-icon cc-icon-logic"></i>
    <span>
      <span> {{ logicRule.rule.logicOperator }} any of these values: </span>
      <span> {{ getRuleValues(logicRule.rule, logicRule.values | async) }} </span>
    </span>
  </div>
  <div [dragula]="logicRule.rule.id">
    <cc-register-view-setting-field
      *ngFor="let dependentField of logicRule.fields"
      [fieldSetting]="dependentField"
      [fieldSettings]="fieldSettings"
      [templateFields]="templateFields"
      [attr.data-field-id]="dependentField.itemId"
      (change)="onFieldSelectionChange.emit()"
      class="dependent"
    ></cc-register-view-setting-field>
  </div>
</div>
